import useLocalStorage from "@rehooks/local-storage";

export default function useDarkMode() {
  const [theme] = useLocalStorage("theme");

  if (typeof window === "undefined") return false;

  if (theme) {
    return theme === "dark";
  }

  return window.matchMedia("(prefers-color-scheme: dark)").matches;
}
